import { Button } from "./ui/button";
import { Phone, Calendar, Calculator } from "lucide-react";

const MobileStickyCTA = () => {
  const scrollToROI = () => {
    const roiSection = document.getElementById('neil-roi');
    if (roiSection) {
      roiSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="fixed bottom-3 left-3 right-3 z-50 flex gap-2 md:hidden" role="navigation" aria-label="Quick actions">
      <a 
        href="tel:+13369624539" 
        className="flex-1"
        aria-label="Call Neil AI at 336-962-4539"
      >
        <Button
          size="sm"
          className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-bold rounded-xl shadow-2xl flex items-center justify-center gap-2 focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-all"
        >
          <Phone className="h-4 w-4" aria-hidden="true" />
          Call
        </Button>
      </a>
      
      <a 
        href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="flex-1"
        aria-label="Book a demo with Neil AI (opens in new window)"
      >
        <Button
          size="sm"
          className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-bold rounded-xl shadow-2xl flex items-center justify-center gap-2 shadow-[0_0_20px_rgba(0,255,200,0.4)] focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-all"
        >
          <Calendar className="h-4 w-4" aria-hidden="true" />
          Book Demo
        </Button>
      </a>
      
      <Button
        size="sm"
        onClick={scrollToROI}
        className="flex-1 glass-effect border border-[hsl(var(--line))] hover:bg-white/10 font-bold rounded-xl shadow-2xl focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-all"
        aria-label="Scroll to ROI calculator"
      >
        <Calculator className="h-4 w-4" aria-hidden="true" />
        ROI
      </Button>
    </div>
  );
};

export default MobileStickyCTA;
